/**
 * Small display-label lookups shared across the public site and staff
 * console. MDA codes here are exactly the ones already used as `mda` /
 * `ownerMda` / `targetMda` values in c11-opengov's own seed fixtures
 * (packages/modules/c11-opengov/seed/seed.ts) plus a couple more real
 * Seychelles MDAs used elsewhere in this platform, so filters/selects built
 * from this list actually match real data.
 */

export const MDA_OPTIONS: Array<{ code: string; name: string }> = [
  { code: 'MOF', name: 'Ministry of Finance, Economic Planning, Trade & Investment' },
  { code: 'MOH', name: 'Ministry of Health' },
  { code: 'SRC', name: 'Seychelles Revenue Commission' },
  { code: 'IMM', name: 'Department of Immigration' },
  { code: 'ELS', name: 'Ministry of Employment & Social Affairs' },
  { code: 'LAND', name: 'Land Registry — Ministry of Lands & Housing' },
  { code: 'DICT', name: 'Department of Information Communications Technology' },
  { code: 'MTC', name: 'Ministry of Tourism & Culture' },
];

export function mdaName(code: string | null | undefined): string {
  if (!code) return '—';
  return MDA_OPTIONS.find((m) => m.code === code)?.name ?? code;
}

export const NOTICE_TYPE_LABELS: Record<string, string> = {
  GAZETTE: 'Gazette notice',
  TENDER: 'Tender',
  PLANNING: 'Planning application',
  LICENCE: 'Licence',
};

export const UPDATE_FREQUENCY_LABELS: Record<string, string> = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  ANNUAL: 'Annual',
};

export const TENURE_TYPE_LABELS: Record<string, string> = {
  FREEHOLD: 'Freehold',
  LEASEHOLD: 'Leasehold',
  STATE_LAND: 'State land',
  CROWN_LAND: 'Crown land',
};

export const FOI_STATE_LABELS: Record<string, string> = {
  RECEIVED: 'Received',
  ASSIGNED: 'Assigned to an officer',
  RESPONDED: 'Responded',
  APPEALED: 'Under appeal',
};
